import React from 'react';
import './About.css';

function About({ language }) {
  return (
    <section id="about" className="section-light">
      <div className="container">
        <div className="about-content">
          <div className="about-image">
            <img src="/images/mengzhe-wang.jpg" alt="Maggie (Mengzhe) Wang" />
          </div>
          <div className="about-text">
            <h2>About Maggie</h2>
            <p>As a dedicated real estate agent, I am committed to providing exceptional service to my clients. With a passion for helping people achieve their real estate goals, I strive to make the buying and selling process as seamless as possible. Whether you're a first-time buyer or a seasoned investor, I'm here to guide you every step of the way.</p>

            <div className="stats">
              <div className="stat-item">
                <div className="stat-number">15+</div>
                <div className="stat-text">Years Experience</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">200+</div>
                <div className="stat-text">Happy Clients</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">$100M+</div>
                <div className="stat-text">Property Sold</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
